import Vue from 'vue';
import App from './App';
import { router } from './router';

import iView from 'iview';
import Element from 'element-ui'
import EmojiInput from '@/components/emoji-input'
import 'vant/lib/index.css';
// import { Table,TableColumn,Button,Input,Dialog,Radio,Pagination,DatePicker,Upload, Popover, Loading} from 'element-ui';

import store from '@/store';
import './resources/scss/theme/theme.less';
import './element-variables.scss'
import moment from 'moment'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

Vue.config.productionTip = false;
Vue.prototype.$moment = moment
Vue.use(iView, {
  transfer: true,
  size: 'large'
});
Vue.prototype.$Message.config({
  top: 100
})

Vue.use(Element, {size: 'medium', zIndex: 3000})
Vue.use(EmojiInput)



// // 结合业务需求 使用elementUI的table组件。当前使用的elementUI仅按需加载
// Vue.component(Table.name,Table);
// Vue.component(TableColumn.name,TableColumn);
// Vue.component(Button.name,Button);
// Vue.component(Input.name,Input);
// Vue.component(Dialog.name,Dialog);
// Vue.component(Radio.name,Radio);
// Vue.component(Pagination.name,Pagination);
// Vue.component(DatePicker.name,DatePicker);
// Vue.component(Upload.name,Upload);
// Vue.component(Popover.name, Popover);

// Vue.use(Loading.directive);

new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>',
  mounted() {
    this.$store.commit('updateMenuLists');
  },
  watch: {
    $route(to) {
      this.$store.commit('updateMenuLists');
      this.$store.commit('setCurrentPath', {
        routerInfo: to
      });
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js